export default __webpack_public_path__ + "static/media/p2023-27.1d45de13.jpeg";